import React from "react";
import ArticleWorkspace from "../../components/MainAdmin/Articles/ArticleWorkspace";
export default function MainAdminEditNewsRelease() {
  return <ArticleWorkspace editing />;
}
